export default {"src":"/_next/static/media/Bingoal.a938fcfb.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};